import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface MswIssueListState {
}

export default {
  state : {},
  actions: {
    fetchIssueListHeaders(context: ActionContext<MswIssueListState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const url = 'users/get-newissuelist-Headers';
      return ApiServiceWrapper.get(url);
    },
    getnewIssueListDetails(context: ActionContext<MswIssueListState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const url = 'users/get-newissuelist-Details';
      return ApiServiceWrapper.post(url, payload);
    },
  },
  namespaced: true,
} as Module<MswIssueListState, RootStoreState>;
